import { createContext } from 'react';
import { useCurrentOrderAddItemsMutation } from '../api';

const CurrentOrderMutationContext = createContext<{
  currentOrderAddItems: ReturnType<typeof useCurrentOrderAddItemsMutation>;
}>(null);

export default CurrentOrderMutationContext;
